import React from "react";
import utils from "../../utils";

const useFetchSchoolDetails = (schoolId = null) => {

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [schoolDetail, setSchoolDetail] = React.useState(null);

  const fetchSchool = React.useCallback(async () => {
    if (schoolId) {
      await utils.fetchSchoolCallback(setLoading, setError, schoolId, setSchoolDetail);
    }
  }, [schoolId]);

  React.useEffect(() => {
    fetchSchool();
  }, [fetchSchool]);

  return { schoolDetail, loading, error, fetchSchool };
};

export default useFetchSchoolDetails;
